import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Tabs, Tab, Box, Typography, IconButton } from "@mui/material";
import MinimizeIcon from "@mui/icons-material/Minimize";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const IA_SERVICES = [
  { key: "ollama", label: "Ollama" },
  { key: "gpt4", label: "OpenAI GPT-4" },
  { key: "gemini", label: "Gemini" },
  { key: "claude", label: "Claude" },
  { key: "deepseek", label: "Deepseek" },
  // Ajouter d'autres APIs ici si besoin
];

export default function IAConfigDialog({ open, onClose, initialConfig = {}, onSave }) {
  const [tab, setTab] = useState(0);
  const [config, setConfig] = useState(initialConfig);
  const [fullscreen, setFullscreen] = useState(false);
  const [minimized, setMinimized] = useState(false);

  const handleChange = (service, field, value) => {
    setConfig(prev => ({
      ...prev,
      [service]: {
        ...prev[service],
        [field]: value
      }
    }));
  };

  const handleSave = () => {
    if (onSave) onSave(config);
    if (onClose) onClose();
  };

  if (!open) return null;
  if (minimized) return (
    <Box sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 2000 }}>
      <Button
        variant="contained"
        startIcon={<FullscreenIcon />}
        onClick={() => setMinimized(false)}
      >
        IA
      </Button>
    </Box>
  );
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={fullscreen}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>Configuration des APIs IA</span>
        <span>
          <IconButton onClick={() => setMinimized(true)} size="small" title="Minimiser">
            <MinimizeIcon />
          </IconButton>
          <IconButton onClick={() => setFullscreen(f => !f)} size="small" title={fullscreen ? "Quitter le plein écran" : "Plein écran"}>
            {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
          <IconButton onClick={onClose} size="small" title="Fermer">
            ×
          </IconButton>
        </span>
      </DialogTitle>
      <DialogContent>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          {IA_SERVICES.map((svc, idx) => (
            <Tab key={svc.key} label={svc.label} />
          ))}
        </Tabs>
        {IA_SERVICES.map((svc, idx) => (
          <Box key={svc.key} sx={{ display: tab === idx ? 'block' : 'none', mt: 2 }}>
            <Typography variant="h6" gutterBottom>{svc.label}</Typography>
            <Button
              variant="outlined"
              color="error"
              sx={{ mb: 2 }}
              onClick={() => {
                setConfig(prev => {
                  const copy = { ...prev };
                  delete copy[svc.key];
                  return copy;
                });
              }}
              disabled={!config[svc.key]}
            >
              Supprimer cette configuration
            </Button>
            <TextField
              label="URL du service IA"
              fullWidth
              margin="normal"
              value={config[svc.key]?.url || ''}
              onChange={e => handleChange(svc.key, 'url', e.target.value)}
            />
            <TextField
              label="Nom du modèle IA"
              fullWidth
              margin="normal"
              value={config[svc.key]?.model || ''}
              onChange={e => handleChange(svc.key, 'model', e.target.value)}
            />
            <TextField
              label="API Endpoint (optionnel)"
              fullWidth
              margin="normal"
              value={config[svc.key]?.endpoint || ''}
              onChange={e => handleChange(svc.key, 'endpoint', e.target.value)}
            />
            <TextField
              label="API Key / Secret"
              fullWidth
              margin="normal"
              value={config[svc.key]?.apiKey || ''}
              onChange={e => handleChange(svc.key, 'apiKey', e.target.value)}
              type="password"
            />
            {/* Ajouter d'autres champs spécifiques ici si besoin */}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button variant="contained" onClick={handleSave}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  );
}
